export function createServicekleberFromTibModel(tibModel) {
  console.info("createServicekleberFromTibModel");
  var journal = [];
  if (tibModel.journal) {
    journal = JSON.parse(tibModel.journal);
  }
  return {
    tib: tibModel,
    data: JSON.parse(tibModel.data),
    banner: null,
    images: [],
    tibs: [],
    journal: journal
  };
}
